<template>
  <div id="app" class="container">
    <div id="nav" class="app-header">
      <AppHeader />
    </div>
    <div v-if="showModalSignUp === true" class="app-main">
      <SignUp />
    </div>
    <div v-if="visitorState === 'pending'"  class="app-main">
      <EmailSent />
    </div>
    <div v-else-if="showModalLogin === true"  class="app-main">
      <Login />
    </div>
    <div v-else-if="showModalReset === true"  class="app-main">
      <Reset />
    </div>
    <div v-else-if="visitorState === 'existing' && userState === 'auth'"  class="app-main">
      <Discerner />
    </div>
    <div v-else-if="showModalSignUp === false" class="app-main">
      <Welcome />
    </div>
    <div class="app-addbar">
      <UserDocs />
    </div>
    <div class="app-sidebar">
      Inside sidebar
    </div>
    <div class="app-footer">
      app footer
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import SignUp from '@/auth/signup.vue';
import Login from '@/auth/login.vue';
import EmailSent from '@/components/emailSent.vue';
import Discerner from '@/views/discerner.vue';
import Reset from '@/auth/reset.vue';
import AppHeader from '@/nav/appHeader.vue';
import Welcome from '@/views/welcome.vue';
import UserDocs from '@/components/userDocuments.vue';

export default {
  components:{
    SignUp,
    Login,
    EmailSent,
    Discerner,
    Reset,
    AppHeader,
    Welcome,
    UserDocs
  },
    data() {
        return {
          doclist:[]
        }
  },
  created(){
    // this.listDocuments(this.$cookies.get("dw_id"));
    // this.getAvailableDocuments;
  },
  computed: {
    ...mapGetters(['getVisitorStatus', 'getUserStatus', 'getLoginForm', 'getSigninForm', 'getResetForm', 'getAvailableDocuments']),
    showModalLogin(){
      if(this.getLoginForm){
        return true;
      } else {
        return false;
      }
    },
    showModalSignUp(){
      if(this.getSigninForm){
        return true;
      } else {
        return false;
      }
    },
    showModalReset(){
      if(this.getResetForm){
        return true;
      } else {
        return false;
      }
    },
    visitorState(){
      return this.getVisitorStatus;
    },
    userState(){
      return this.getUserStatus;
    },
    documentState(){
      return this.getAvailableDocuments;
      // this.doclist = this.getAvailableDocuments;
      // return this.doclist;
    }
  },
  methods: {
    ...mapActions(['updateUserStatus', 'updateVisitorStatus', 'listDocuments'])
  },

}
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
.container {
  display: grid;
  grid-template-columns: 1fr 4fr 1fr;
  grid-template-rows: auto;
  grid-template-areas:
    "header header header"
    "addbar main  sidebar"
    "footer footer footer";
}
.app-header {
  grid-area: header;
}
.app-main {
  grid-area: main;
  min-height: 75vh;
  border: solid red 1px;
}
.app-addbar {
  grid-area: addbar;
}
.app-sidebar {
  grid-area: sidebar;
}
.app-footer {
  border: solid green 1px;
  grid-area: footer;
  align-self: end;
  min-height: 7vh;
}
</style>
